export * from "./private-template";